import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Col, Form, Row, Switch } from "antd";
import { EUserRole, ServiceTemplateField, TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../../others/i18n.js";
import { spacing } from "../../../../../../styles/spacing.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
function FormFieldServiceTemplateIsExecuteCodeOptOutWhenNoTagManagerConsentIsGiven() {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ServiceTemplateField.ExecuteCodeOptOutWhenNoTagManagerConsentIsGiven,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(ServiceTemplateField.ExecuteCodeOptOutWhenNoTagManagerConsentIsGiven, t),
            shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier,
            children: ({ getFieldValue })=>{
                const extended = getFieldValue(TemplateMetaDataField.Extends);
                return /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                    extendsFieldName: ServiceTemplateField.ExecuteCodeOptOutWhenNoTagManagerConsentIsGiven,
                    disableStrategies: getDisableStrategies(),
                    onKeepContent: extended && /*#__PURE__*/ _jsx(Switch, {
                        disabled: true,
                        checked: extended[ServiceTemplateField.ExecuteCodeOptOutWhenNoTagManagerConsentIsGiven]
                    }),
                    children: /*#__PURE__*/ _jsxs(Row, {
                        style: {
                            display: "flex",
                            alignItems: "baseline"
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Col, {
                                children: /*#__PURE__*/ _jsx(Form.Item, {
                                    name: ServiceTemplateField.ExecuteCodeOptOutWhenNoTagManagerConsentIsGiven,
                                    valuePropName: "checked",
                                    noStyle: true,
                                    children: /*#__PURE__*/ _jsx(Switch, {})
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                style: {
                                    paddingLeft: spacing.layout.content.padding
                                },
                                children: t("Only run this script if the user has not allowed to use Google Tag Manager")
                            })
                        ]
                    })
                });
            }
        })
    });
}
export { FormFieldServiceTemplateIsExecuteCodeOptOutWhenNoTagManagerConsentIsGiven };
